import { axiosIns } from "../utils";

export const fetchProfessionals = async () => {
  const res = await axiosIns.get("/professionals/");
  return res && res.data ? res.data : res;
};

export const certifyProfessionalApi = async (id, payload, method = "put") => {
  const normalizedMethod = String(method || "put").toLowerCase();
  const fn = normalizedMethod === "patch" ? axiosIns.patch : axiosIns.put;
  const res = await fn(`/professional/${id}/certify/`, payload);
  return res && res.data ? res.data : res;
};
